<template>
  <v-timeline-item color="primary" icon="add" small>
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ addendum.created }}</strong>
      </v-flex>
      <v-flex>
        <strong>Nueva adenda: </strong>
        <span>{{ addendum.title }}</span>
        <span v-if="addendum.endDate !== null"> (Prórroga el contrato hasta el {{ addendum.endDate }})</span>
        <a :href="addendum.asset.url" target="_blank" class="addenda-link ml-2">
          Visualizar
          <v-tooltip bottom>
            <v-icon small slot="activator" color="primary">open_in_new</v-icon>
            <span>Visualizar adenda</span>
          </v-tooltip>
        </a>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
export default {
  props: {
    addendum: Object
  }
}
</script>

<style scoped>
.addenda-link {
  text-decoration: none !important;
}
</style>
